import React, { useEffect, useState } from "react";
import {
  Table,
  Divider,
  PageHeader,
  Button,
  Form,
  Select,
  Input,
  message,
  Modal,
  Segmented,
  Radio,
  Checkbox,
  DatePicker,
  Image,
} from "antd";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../Common/Container.styles";

import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

import * as commonAPI from "../../api/common";

import {
  dateToCompactString,
  dateToString,
  numberWithCommas,
} from "../../util/common";

import Pagination from "react-js-pagination";
import { Option } from "antd/lib/mentions";
import { useRecoilState } from "recoil";
import { searchItemState } from "../../states/atoms";
import TextArea from "antd/lib/input/TextArea";
import {getCertificates} from "../../api/user";
import {editInquiry} from "../../api/common";
import * as userAPI from "../../api/user";

export default function CertificateList() {
  const [searchItem, setSearchItem] = useRecoilState(searchItemState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("전체");

  const [startCreatedDate, setStartCreatedDate] = useState(null);
  const [endCreatedDate, setEndCreatedDate] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  const [form] = Form.useForm();

  const searchQuery = Form.useWatch("searchQuery", form);
  const searchKeyword = Form.useWatch("searchKeyword", form);
  const status = Form.useWatch("status", form);
  const bannering = Form.useWatch("bannering", form);
  const size = Form.useWatch("size", form);

  const fetchItems = () => {
    const request = {
      page: current,
      size: size ?? 50,
      startCreatedDate,
      endCreatedDate,
    };
    request[`${searchQuery}`] = searchKeyword;
    request[`${searchItem.searchQuery}`] = searchItem.searchKeyword;

    commonAPI.getInquiries(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setItems(res.data.data?.map((item) => {return {...item, key: item?.id}}))
        setLoading(false);
      } else {
        alert(res.data.data.msg);
      }
    });
  };

  useEffect(() => {
    if (current !== 1) {
      setCurrent(1);
      return;
    }

    setLoading(true);
    fetchItems();
  }, [filter, startCreatedDate, endCreatedDate, status, bannering, size, searchItem]);

  useEffect(() => {
    setLoading(true);
    fetchItems();
  }, [current]);

  const onSearch = (e) => {
    if (!searchQuery) {
      message.error("검색조건을 선택해주세요.");
      return;
    }

    if (!searchKeyword) {
      message.error("검색 키워드를 입력해주세요.");
      return;
    }

    const newSearchItem = {
      ...searchItem,
      searchQuery: searchQuery,
      searchKeyword: searchKeyword,
    };
    setSearchItem(newSearchItem);

    setCurrent(1);
    sessionStorage.setItem("page", 1);

    setLoading(true);
    // fetchItems();
  };

  const editStatus = (id, status) => {
    commonAPI.editInquiry({id, status}).then((res) => {
      if (res.data.linusCode === 1) {
        fetchItems()
        message.success('답변 완료 처리 되었습니다.')
      }
    })
  }

  const editAllStatus = () => {
    let requests = selectedItems?.map((i) => {
      return commonAPI.editInquiry({
        id: i.id,
        status: '답변 완료',
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchItems();
        message.success("변경이 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }

  const deleteAllInquiries = () => {
    let requests = selectedItems?.map((i) => {
      return commonAPI.deleteInquiry({
        id: i.id,
      });
    });

    Promise.all(requests)
      .then((res) => {
        fetchItems();
        message.success("삭제가 완료되었습니다.");
      })
      .catch((error) => {
        if (error?.response?.data?.data?.msg) {
          alert(error.response.data.data.msg);
        }
      });
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedItems(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled Banner",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // 주문번호, 닉네임, 가입채널, 가입년월일시, 최종로그인년월일시, 마케팅동의여부
  const columns = [
    { title: "ID", dataIndex: "id" },
    {
      title: "유저 이메일",
      dataIndex: "user",
      width: '5%',
      render: (val) => {
        return val?.email ?? '-'
      },
    },
    // {
    //   title: "연락처",
    //   dataIndex: "phone",
    //   render: (val) => {
    //     return val ?? '-'
    //   },
    // },
    {
      title: "답변받을 이메일 / 연락처",
      dataIndex: "email",
      render: (val, obj) => {
        return (
          <div>
            <div>{val ?? '-'}</div>
            <div>{obj.phone ?? '-'}</div>
          </div>
        )
      },
    },
    {
      title: "날짜",
      dataIndex: "date",
      render: (val) => {
        return val ? val?.split('T')[0] : '-'
      },
    },
    {
      title: "제목",
      dataIndex: "title",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "문의 내용",
      dataIndex: "content",
      width: "20%",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "이미지",
      dataIndex: "image",
      render: (val) => {
        return (
          val ?
          <img src={val} style={{maxWidth: 50}} onClick={() => window.open(val)}/>
            :
          null
        )
      },
    },
    // {
    //   title: "생성 시각",
    //   dataIndex: "createdDate",
    //   render: (val) => {
    //     return dateToString(val);
    //   },
    // },
    {
      title: "문의 처리",
      render: (val) => {
        return (
          <Button
            onClick={() => editStatus(val?.id, val?.status === '답변 대기' ? '답변 완료' : '답변 대기')}
            style={{color: val?.status === '답변 대기' ? 'blue' : 'red'}}
          >
            {val?.status === '답변 대기' ? '답변 완료' : '답변 대기'}
          </Button>
        )
      },
    },
    {
      title: "문의 상태",
      dataIndex: "status",
      width: '10%',
      render: (val) => {
        return (
          <div style={{color: val === '답변 대기' ? 'red' : 'blue'}}>{val ?? '-'}</div>
        )
      },
    },
  ];

  const searchQueries = [
    {
      title: "유저 이메일",
      dataIndex: "userEmail",
    },
    {
      title: "이메일",
      dataIndex: "email",
    },
    {
      title: "연락처",
      dataIndex: "phone",
    },
    {
      title: "날짜",
      dataIndex: "date",
    },
    {
      title: "제목",
      dataIndex: "title",
    },
    {
      title: "문의 내용",
      dataIndex: "content",
    },
    {
      title: "문의 상태",
      dataIndex: "status",
    },
  ];

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="의뢰 목록"
        subTitle={`총 ${total}개의 의뢰 내역이 존재합니다.`}
      />
      <Form form={form} onFinish={onSearch}>
        <FlexRowContainer style={{ marginTop: "10px" }}>
          <FlexRowQuarterContainer>
            <Form.Item name="searchQuery" initialValue={searchItem.searchQuery}>
              <Select placeholder="검색조건" style={{width: 100}}>
                {searchQueries?.map((c) => {
                  return (
                    <Select.Option key={c.dataIndex} value={c.dataIndex}>
                      {c.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="searchKeyword"
              initialValue={searchItem.searchKeyword}
            >
              <Input placeholder="검색 키워드를 입력하세요" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              />
            </Form.Item>
          </FlexRowQuarterContainer>
        </FlexRowContainer>
      </Form>
      <FlexRowEndContainer>
        <Button
          style={{marginRight: 10}}
          onClick={e => {
            e.preventDefault()
            editAllStatus()
          }}
        >
          일괄 답변 완료
        </Button>
        <Button
          danger
          onClick={e => {
            e.preventDefault()
            if (window.confirm('정말 선택된 항목을 모두 삭제 하시겠습니까?')) {
              deleteAllInquiries()
            }
          }}
        >
          일괄 삭제
        </Button>
      </FlexRowEndContainer>
      <Divider />
      <Table
        pagination={false}
        loading={loading}
        columns={columns}
        dataSource={items}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: (event) => {
        //       navigate(`/setting/banner/edit/${record.id}/`);
        //     }, // click row
        //     onDoubleClick: (event) => {}, // double click row
        //     onContextMenu: (event) => {}, // right button click row
        //     onMouseEnter: (event) => {}, // mouse enter row
        //     onMouseLeave: (event) => {}, // mouse leave row
        //   };
        // }}
      />
      <FlexRowEndContainer style={{ marginTop: "30px" }}>
        <Pagination
          activePage={current}
          itemsCountPerPage={size ?? 50}
          totalItemsCount={total}
          pageRangeDisplayed={10}
          onChange={onChange}
        />
      </FlexRowEndContainer>
    </div>
  );
}
